import { render } from "./index.vue?vue&type=template&id=46225fee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal/TrfModalTransferirTarefa/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46225fee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46225fee', __exports__)) {
    console.log('reload')
    api.reload('46225fee', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=46225fee", () => {
    console.log('re-render')
    api.rerender('46225fee', render)
  })

}


export default __exports__